module.exports = __webpack_public_path__ + "media/images/lb/057-4cf43bdff8fc96baa2856ea9a55c9345.svg";